
// Vendor
import { defineComponent } from 'vue';

export default defineComponent({
  /**
   * Properties
   */
  props: {
    label: { type: String, default: '' },
    loadingLabel: { type: String, default: null },
    type: { type: String, default: '' },
    disable: { type: Boolean, default: false },
    flat: { type: Boolean, default: true },
    rounded: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    vClosePopup: { type: Boolean, default: false },
    iconLeft: { type: String, default: undefined },
    iconRight: { type: String, default: undefined },
    title: { type: String, default: undefined },
  },
  emits: ['click'],

  setup(props, context) {
    return {
      onCancelClick() {
        context.emit('click');
      },
    };
  },
});
